import type { GroupPublic } from '@repo/types/groups';

import { Users } from 'lucide-react';
import { Link } from 'react-router';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getAvatar } from '@/utils/getAvatar';

/**
 * Props for the GroupSecondaryCard component.
 * @property {GroupPublic} group - The group data to display.
 */
interface GroupSecondaryCardProps {
  group: GroupPublic;
}

export default function GroupSecondaryCard(groupSecondaryCardProps: GroupSecondaryCardProps) {
  const { group } = groupSecondaryCardProps;
  const { id, name, desc, avatarURL } = group;

  return (
    <Link className={'group flex h-fit items-center justify-between gap-3 rounded-md py-2'} to={`/groups/${id}`}>
      <div className={'flex items-center gap-3'}>
        <Avatar size={'sm'}>
          <AvatarImage alt={'avatar'} src={getAvatar(avatarURL)} />
          <AvatarFallback>
            <Users />
          </AvatarFallback>
        </Avatar>
        <div className={'flex flex-col gap-1'}>
          <h5 className={'text-md w-full truncate'}>{name}</h5>
          <small className={'text-muted-foreground truncate text-xs'}>{desc}</small>
        </div>
      </div>
    </Link>
  );
}
